import { render, staticRenderFns } from "./Carorder.vue?vue&type=template&id=c93bc544&scoped=true&"
import script from "./Carorder.vue?vue&type=script&lang=ts&"
export * from "./Carorder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c93bc544",
  null
  
)

export default component.exports